/**
 * Контрольна кнопка Sidebar меню
 * (десктопна та мобільні версії)
 * 
 */

import SolarHamburgerMenuLinear from '../../icons/SolarHamburgerMenuLinear';


const SideBarCtrlButton = ({pcSideBarShow, 
                            setPcSideBarShow,
                            mobSideBarShow,
                            setMobSideBarShow}) =>{

    // Контролюємо стан меню для широкого екрану
    const handlePcClick = () => {
        setPcSideBarShow(!pcSideBarShow);
    }

    // Контролює стан меню дл мобільної версії
    const handleMobClick = () => {
        setMobSideBarShow(!mobSideBarShow);
    }
  
    return (
        <>
            <div className="pc-h-item pc-sidebar-collapse ">
                <span className="pc-head-link ms-0 cursor-pointer"
                    onClick={handlePcClick}>
                    <SolarHamburgerMenuLinear/>
                </span>
            </div>
            <div className="pc-h-item pc-sidebar-popup">
                <span className="pc-head-link ms-0"
                    onClick={handleMobClick}>
                        <SolarHamburgerMenuLinear/>
                </span>
            </div>
        </>
    )
}
 
export default SideBarCtrlButton;